import React from "react";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import ScrollToTop from "../src/components/ScrollToTop/ScrollToTop";

// Import styles bootstrap
import "./styles/global.scss";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import { SWRConfig } from "swr";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <SWRConfig
        value={{
          provider: () => new Map(), // Simple global Map
          keepPreviousData: true,
          revalidateOnFocus: false,
          revalidateIfStale: false,
          revalidateOnReconnect: false,
        }}
      >
        <App />
        <ScrollToTop />
      </SWRConfig>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// For activate service worker change to register()
serviceWorkerRegistration.register();
